export default "__VITE_ASSET__uF_eLAhN__"